import { render } from "./printReceipt.vue?vue&type=template&id=3fcb9b3f"
import script from "./printReceipt.vue?vue&type=script&lang=js"
export * from "./printReceipt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__